import { useContentfulTranslations } from "@/utils/contentfulTranslations";
import styles from "./index.module.scss";
import { useLocale } from "@/hooks/useLocale";

const PrintFooter = () => {
  let locale = useLocale();
  const { printFooterText } = useContentfulTranslations();

  return (
    <div className={styles.printFooter}>
      <p className="text-[12px]">
        <strong className="text-[15px]">
          {printFooterText?.questionsText?.[locale]}
        </strong>
      </p>
      <p className="text-[12px]">{printFooterText?.copyrightText?.[locale]}</p>
    </div>
  );
};

export default PrintFooter;
